<div class="container-fluid">
  <div class="row">
    <div class="col-10 p-0 footer-left">
      <p class="mb-0">Copyright 2023 © MunciPal by ITServices</p>
    </div>
    <div class="col-2 p-0 footer-right">
      <i class="fa fa-heart font-danger"> </i>
    </div>
  </div>
</div>
